module.exports = __webpack_public_path__ + "static/media/Apartment-bluo.582bebf1.png";